var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-monospace",attrs:{"title":_vm.amount +' '+ _vm.sym}},[_vm._v("\n    "+_vm._s(_vm.noPretty? _vm.amount: _vm.pretty)+"\n    "),_c('span',{staticClass:"text-secondary small ml-1",staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.sym))])])
}
var staticRenderFns = []

export { render, staticRenderFns }